import { AlertLineReportNoteDTO } from "src/models/alert-line-report-note/alert-line-report-note-dto";
import { AlertLineReportNoteSTO } from "src/models/alert-line-report-note/alert-line-report-note-sto";
import { BaseApiService } from "../base";

export class PublicAlertLineReportNotesApiService extends BaseApiService<
  AlertLineReportNoteDTO,
  AlertLineReportNoteSTO
> {
  constructor() {
    super({
      servicePath: "/AlertLine",
      loadItemsPath: "/GetPublicAlertLineReportNotes",
      saveItemsPath: "/SavePublicAlertLineReportNotes",
    });
  }
}
